<template>
    <div class="mt-5">
        <v-layout row>
            <v-flex md6>
                <h3>{{data.title}}</h3>
            </v-flex>
            <v-flex md6 class="text-md-right">

                <a
                  v-if = "data.export_url"
                  :href = "data.export_url"
                  class = "excel-btn"
                  target = "_blank">
                      Download Data
                </a>
                <JsonExcel
                  v-else
                  class="excel-btn"
                  :data = "data.data">
                    Download Data
                </JsonExcel>

            </v-flex>
        </v-layout>
        <v-data-table
          :headers="headers"
          :items="data.data"
        >
            <template v-slot:items="props">
                <td class="text-xs-center" v-for="(value, key) in props.item">
                    {{ value }}
                </td>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import common from '../../../utils/common'
    import JsonExcel from 'vue-json-excel'
    export default {
        name: "table",
        components: {
            JsonExcel
        },
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            }
        },
        data () {
            return {
                common,
                headers: [

                    // { text: 'Actions', value: 'name', sortable: false, align: 'center', }
                ],
            }
        },
        mounted() {

            for (let property in this.data.data[0]) {
                if (this.data.data[0].hasOwnProperty(property)) {
                    this.headers.push(
                      {
                          text: property,
                          align: 'center',
                          sortable: false,
                          value: property
                      },
                    )
                }
            }


        }
    }
</script>

<style >
    .excel-btn {
        display: inline-block;
        width: auto;
        padding: 10px 19px;
        background: #059BFF;
        color: white;
        border-radius: 37px;
        cursor: pointer;
    }
</style>